/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Divider } from '@mui/material';
import styles from './softwareAndHardwareCost.module.scss';

const SummarySection = ({ title, totalCost, insights, chartData, colors }) => {
  return (
    <div className={styles['software-summary']}>
      <div className={styles['software-info']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['container']}>
          <div className={styles['cost-display']}>{`₹ ${totalCost}`}</div>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          {insights.map((item, index) => (
            <div
              key={item.resource}
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <div
                style={{
                  width: '4px',
                  height: '12px',
                  borderRadius: '4px',
                  background: colors[index % colors.length],
                }}
              />
              <div className={styles['jira-tags']}>{item.resource}</div>
              {index < insights.length - 1 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ borderWidth: '1px' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
      {chartData.length > 0 && (
        <div className={styles['software-chart']}>
          <PieChart
            series={[
              {
                data: chartData,
                arcLabel: (item) => `${item.value}%`,
                arcLabelMinAngle: 35,
                arcLabelRadius: '60%',
                strokeWidth: 0,
                cx: 100,
                cy: 70,
              },
            ]}
            height={136}
            width={200}
            sx={{
              [`& .${pieArcLabelClasses.root}`]: {
                ...styles['software-chart'],
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

const SummaryContainer = ({
  softwareInsights,
  hardwareInsights,
  softwareTotalCost,
  hardwareTotalCost,
  nameAndLogo,
}) => {
  const colors = ['#43D590', '#7BC9FF', '#FFDCE0'];

  const mapInsightsToChartData = (insights) =>
    insights.map((item, index) => ({
      id: index,
      value: item.percentage,
      color: colors[index % colors.length],
    }));

  const softwareChartData = mapInsightsToChartData(softwareInsights);
  const hardwareChartData = mapInsightsToChartData(hardwareInsights);

  return (
    <div className={styles['container1']}>
      <div className={styles['summary']}>
        Software and Hardware Cost Summary
      </div>
      <Divider sx={{ bgcolor: '#FFFF' }} />
      {nameAndLogo && (
        <div className={styles['logo-project-name']}>
          <div className={styles['logo']}>
            <img src={nameAndLogo} alt={nameAndLogo} />
          </div>
          <div className={styles['name-effort']}>
            <div className={styles['name']}>{nameAndLogo}</div>
          </div>
        </div>
      )}
      <div className={styles['summary-container']}>
        <SummarySection
          title="Software Cost"
          totalCost={softwareTotalCost}
          insights={softwareInsights}
          chartData={softwareChartData}
          colors={colors}
        />
        <SummarySection
          title="Hardware Cost"
          totalCost={hardwareTotalCost}
          insights={hardwareInsights}
          chartData={hardwareChartData}
          colors={colors}
        />
      </div>
    </div>
  );
};

const insightsShape = PropTypes.arrayOf(
  PropTypes.shape({
    resource: PropTypes.string.isRequired,
  })
).isRequired;

SummaryContainer.propTypes = {
  softwareInsights: insightsShape,
  hardwareInsights: insightsShape,
  softwareTotalCost: PropTypes.number.isRequired,
  hardwareTotalCost: PropTypes.number.isRequired,
  nameAndLogo: PropTypes.string.isRequired,
};

SummarySection.propTypes = {
  title: PropTypes.string.isRequired,
  totalCost: PropTypes.number.isRequired,
  insights: insightsShape,
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SummaryContainer;
